/* 
 * Lightweight Swiper carousel initialization with lazy loading
 * Only loads when section enters viewport for better mobile performance
 */

(function() {
  'use strict';
  
  // Lightweight intersection observer polyfill fallback
  if (!window.IntersectionObserver) {
    window.IntersectionObserver = function(callback) {
      return {
        observe: function() {
          // Immediate initialization for unsupported browsers
          setTimeout(() => callback([{isIntersecting: true}]), 100);
        },
        unobserve: function() {}
      };
    };
  }

  // Queue for carousel sections waiting to be initialized
  const carouselQueue = [];
  let swiperLibLoaded = false;

  // Lightweight carousel initialization
  function initCarousel(container) {
    const slides = container.querySelectorAll('.swiper-slide');
    const wrapper = container.querySelector('.swiper-wrapper');
    const nextBtn = container.querySelector('.swiper-button-next');
    const prevBtn = container.querySelector('.swiper-button-prev');
    
    if (!slides.length) {
      return;
    }

    // Ensure all images in the carousel are loaded
    const images = container.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
      img.loading = 'eager';
    });

    let currentIndex = 0;
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    // Simple mobile-first touch navigation
    function updateSlide() {
      const slideWidth = slides[0].offsetWidth + 16; // Including gap
      const maxVisible = Math.floor(container.offsetWidth / slideWidth);
      const maxIndex = Math.max(0, slides.length - maxVisible);
      
      currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));
      const translateX = -(currentIndex * slideWidth);
      
      if (wrapper) {
        wrapper.style.transform = `translateX(${translateX}px)`;
        wrapper.style.transition = isDragging ? 'none' : 'transform 0.3s ease';
      }
    }

    // Touch events for mobile
    if (wrapper) {
      wrapper.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
      });

      wrapper.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        currentX = e.touches[0].clientX;
        const diffX = startX - currentX;
        wrapper.style.transform = `translateX(${-(currentIndex * (slides[0].offsetWidth + 16)) - diffX}px)`;
      });

      wrapper.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;
        
        const diffX = startX - currentX;
        if (Math.abs(diffX) > 50) {
          if (diffX > 0) {
            currentIndex++;
          } else {
            currentIndex--;
          }
        }
        updateSlide();
      });
    }

    // Button navigation
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        currentIndex++;
        updateSlide();
      });
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        currentIndex--;
        updateSlide();
      });
    }

    // Handle resize
    window.addEventListener('resize', updateSlide);
    updateSlide();
  }

  // Initialize carousel when it becomes visible
  function setupLazyCarousel(element) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Initialize with basic functionality immediately
          initCarousel(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '50px',
      threshold: 0.1
    });
    
    observer.observe(element);
  }

  // Initialize all carousels when DOM is ready
  function initLazyCarousels() {
    const carousels = document.querySelectorAll('.swiper-container, .ingredients-carousel-container .swiper-container, .reviews-carousel-container .swiper-container');
    
    carousels.forEach(carousel => {
      setupLazyCarousel(carousel);
      
      // EMERGENCY MOBILE FIX - Force proper slide widths
      if (window.innerWidth <= 749) {
        const slides = carousel.querySelectorAll('.swiper-slide');
        slides.forEach(slide => {
          if (slide.closest('.reviews-carousel-container')) {
            // Fix testimonial cards
            slide.style.width = '280px';
            slide.style.minWidth = '280px';
            slide.style.maxWidth = '320px';
            slide.style.marginRight = '15px';
            slide.style.flexShrink = '0';
          } else if (slide.closest('.ingredients-carousel-container')) {
            // Fix ingredient cards
            slide.style.width = '200px';
            slide.style.minWidth = '200px';
            slide.style.maxWidth = '220px';
            slide.style.marginRight = '15px';
            slide.style.flexShrink = '0';
          }
        });
        
        // Fix wrapper display
        const wrapper = carousel.querySelector('.swiper-wrapper');
        if (wrapper) {
          wrapper.style.display = 'flex';
          wrapper.style.flexWrap = 'nowrap';
        }
      }
    });

    // Also ensure any images marked as lazy in carousels are loaded
    const carouselImages = document.querySelectorAll('.swiper-slide img[loading="lazy"]');
    carouselImages.forEach(img => {
      img.loading = 'eager';
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyCarousels);
  } else {
    initLazyCarousels();
  }

})();